import { CALENDAR_GRID_LABEL_SEPARATOR } from '../../../../constants/calendarGrid'
import {
  getAppointmentListDateLabel,
  getIsAppointmentCancelled,
} from '../../../Appointment'

import AppointmentIcon from '../../../../icons/activities/calendar.svg'

export function getEmailProfileWidgetAppointmentItemProps({
  appointment,
  t,
  timezone,
}) {
  return {
    ListIcon: AppointmentIcon,
    description: [
      getAppointmentListDateLabel({ appointment, timezone }),
      getIsAppointmentCancelled(appointment.status)
        ? t('Appointment.StatusCancelledKey')
        : null,
    ]
      .filter(Boolean)
      .join(CALENDAR_GRID_LABEL_SEPARATOR),
    text: appointment.title,
  }
}
